/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TermDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class TermService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags TermService
   * @name GetTermByCategory
   * @summary Get Term by Category
   * @request GET:/v1/terms/{category}
   * @secure
   */
  getTermByCategory = (
    category:
      | 'PRIVACY_POLICY'
      | 'FACILITY_USAGE_POLICY'
      | 'THIRD_PARTY_PRIVACY_POLICY'
      | 'MARKETING_AGREEMENT'
      | 'RESERVATION'
      | 'CHECKIN'
      | 'USAGE',
    query: {
      locale: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TermDto, any>({
      path: `/v1/terms/${category}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
